import { render, staticRenderFns } from "./NavTabs.vue?vue&type=template&id=4d374338&scoped=true&"
import script from "./NavTabs.vue?vue&type=script&lang=js&"
export * from "./NavTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d374338",
  null
  
)

export default component.exports